import { combineReducers, configureStore } from "@reduxjs/toolkit";

import alertSlice from "./slices/alertSlice";
import collaboratorSlice from "./slices/collaboratorSlice";
import mcpKeySlice from "./slices/mcpKeySlice";
import projectSlice from "./slices/projectSlice";
import senioritySlice from "./slices/senioritySlice";
import skillCategorySlice from "./slices/skillCategorySlice";
import teamSlice from "./slices/teamSlice";
import userSlice, { logoutUser } from "./slices/userSlice";

const combinedReducer = combineReducers({
  alertSlice: alertSlice,
  collaboratorSlice: collaboratorSlice,
  mcpKeySlice: mcpKeySlice,
  projectSlice: projectSlice,
  senioritySlice: senioritySlice,
  skillCategorySlice: skillCategorySlice,
  teamSlice: teamSlice,
  userSlice: userSlice,
});

const rootReducer = (state, action) => {
  if (action.type === logoutUser.type) {
    state = undefined;
  }
  return combinedReducer(state, action);
};

const store = configureStore({
  reducer: rootReducer,
});

export default store;
